import { render, staticRenderFns } from "./FunnelList.vue?vue&type=template&id=33606907&scoped=true&"
import script from "./FunnelList.vue?vue&type=script&lang=js&"
export * from "./FunnelList.vue?vue&type=script&lang=js&"
import style0 from "./FunnelList.vue?vue&type=style&index=0&id=33606907&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33606907",
  null
  
)

export default component.exports